import axiosInstance from './axiosCreator';

// Get All Videos
export const getAllVideos = async () => {
  try {
    const response = await axiosInstance.get('/videos/by-level-one');
    return response.data;
  } catch (error) {
    console.error('Error fetching videos:', error);
    throw error;
  }
};

// Increment Video View Count
export const incrementVideoView = async (videoId: string) => {
  try {
    const response = await axiosInstance.post(`/videos/${videoId}/view`);
    return response.data;
  } catch (error) {
    console.error('Error incrementing video view:', error);
    throw error;
  }
};
